// import mainUrl from './main_url'
import { getLogo } from './api'
import request from './request'
export const logoDefault  = (type) => {
    let logoSrc
    if (process.env.NODE_ENV == 'production') {
        logoSrc = `./logo/${type}sign.png`
    } else {
        logoSrc = `/logo/${type}sign.png`
    }
    return logoSrc
}

const logoSet =  (type, tenant) => {
    if (!tenant) {
        tenant = 'sign'
    }
    let logoType = Object.create({
        admin: 2,
        stu: 2,
        login: 3
    })[type]
    // let logoSrc
    return request({
        url: getLogo,
        data: {logoType, tenant}
    })
}

export default logoSet